/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import showErrorMessage from './showErrorMessage';

const errorTypes = {
  'general.system.error': {
    errorTitle: 'System Error Occurred',
    errorMessage: 'A system error has occurred. Contact site administrator.',
  },
  'bpm:general.system.error': {
    errorTitle: 'System Error Occurred',
    errorMessage: 'A system error has occurred. Contact site administrator.',
  },
  'bpm:entity-exists': {
    errorTitle: 'Entity Already Exists',
    errorMessage:
      'An entity with this Tax ID already exists. This means either this entity has already been created within the system, or it was synced from NMLS.',
  },
  'bpm:cm.access.denied': {
    errorTitle: 'Access Denied',
    errorMessage: 'You do not have the required access to perform the requested action.',
  },
  'bpm:existing-naic-code': {
    errorTitle: 'Duplicate NAIC Code',
    errorMessage: 'The provided NAIC Code has already been registered with EMS.',
  },
};

export default function handleAjaxError(event, jqxhr, settings, thrownError) {
  const httpStatusCode = jqxhr?.status;
  const dataType = settings.dataType || '';
  const isSoapRequest = dataType.indexOf('soap') > 0;

  let errorCode = 'general.system.error';
  let showError = false;

  if (httpStatusCode === 403) {
    errorCode = 'bpm:cm.access.denied';
    showError = true;
  } else if (isSoapRequest) {
    errorCode = jqxhr?.message?.code || 'general.system.error';
    showError = true;
  }

  if (showError) {
    const errorType = errorTypes[errorCode] || errorTypes['general.system.error'];

    showErrorMessage({
      errorCode,
      errorTitle: errorType.errorTitle,
      errorMessage: errorType.errorMessage,
    });
  }
}
